// src/pages/ConferirDocumento/components/AnaliseDialog.js
import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

const AnaliseDialog = ({ isOpen, conferencia, onClose }) => {
  if (!isOpen || !conferencia) return null;

  const formatarData = (isoString) => {
    const data = new Date(isoString);
    const dia = String(data.getDate()).padStart(2, '0');
    const mes = String(data.getMonth() + 1).padStart(2, '0');
    const ano = String(data.getFullYear()).slice(-2);
    const hora = String(data.getHours()).padStart(2, '0');
    const min = String(data.getMinutes()).padStart(2, '0');
    return `${dia}/${mes}/${ano} - ${hora}:${min}`;
  };

  const copiarAnalise = () => {
    navigator.clipboard.writeText(conferencia.resultado_analise).then(() => {
      alert('Análise copiada para área de transferência!');
    }).catch(err => {
      console.error('Erro ao copiar:', err);
      alert('Erro ao copiar análise');
    });
  };

  return (
    <div className="dialog-overlay" onClick={onClose}>
      <div className="dialog-content" onClick={(e) => e.stopPropagation()}>
        <div className="dialog-header">
          <h3>📄 Análise: {conferencia.nome_documento}</h3>
          <button className="btn-fechar" onClick={onClose}>✖</button>
        </div>

        <div className="dialog-body">
          <div className="dialog-meta">
            <span><strong>Data:</strong> {formatarData(conferencia.created_at)}</span>
            <span><strong>Tipo:</strong> {conferencia.tipo_analise}</span>
          </div>

          <div className="markdown-container">
            <ReactMarkdown remarkPlugins={[remarkGfm]}>
              {conferencia.resultado_analise}
            </ReactMarkdown>
          </div>
        </div>

        <div className="dialog-footer">
          <button className="btn-copiar" onClick={copiarAnalise}>
            📋 COPIAR ANÁLISE
          </button>
        </div>
      </div>
    </div>
  );
};

export default AnaliseDialog;